import {Injectable} from '@angular/core';
import {UserInteractor} from '../../interactors/user.interactor';
import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';

@Injectable()
export class EmailStep extends PostLoginLoanApplicationFlowStep {
    constructor(userInteractor: UserInteractor) {
        super(userInteractor);
    }

    url(): string {
        return this.createBorrowerFlowUrl('email-verification');
    }

    description(): string {
        return 'To help us reach you';
    }

    displayName(): string {
        return 'Email Verification';
    }

    async isStepComplete(): Promise<boolean> {
        return !!await this.userInteractor.getEmail();
    }
}